import { gql } from '@apollo/client';

const DRAFT_BOOKING = gql`
  mutation DraftBooking($input: draftInput) {
    DraftBooking(input: $input) {
      success
      data
      message
    }
  }
`;

export const PACKAGE_LIST = gql`
  query Query {
    ListPackageTypes
  }
`;

export const BULK_DRAFT_BOOKING = gql`
  mutation BulkCargoRequest($input: bulkBookCRInput) {
    BulkCargoRequest(input: $input) {
      success
      data
      message
    }
  }
`;

export const BULK_PACKAGING_VITRO = gql`
  mutation BulkCargoRequest($input: bulkBookCRInput) {
    BulkCargoRequest(input: $input) {
      data
      message
    }
  }
`;

export default DRAFT_BOOKING;
